<template>
  <div id="app">
    <!-- TODO 角色id替换-->
    <top-bar :isMessage="isMessageShow" :openNotification="iszongbuyusuanLeader"></top-bar>
    <side-bar :links="menu"></side-bar>
    <section id="main" class="main" :class="{'hide-sidebar': !sidebar.opened}">
      <transition name="fade-transform" mode="out-in">
        <!-- 需要被缓存的视图组件 -->
        <!-- <keep-alive v-if="$route.meta.keepAlive" :include="cachedViews">
                <router-view />
        </keep-alive>-->
        <!-- 不需要被缓存的视图组件 -->
        <!-- <router-view v-if="!$route.meta.keepAlive"/> -->
        <router-view @messageShow="messageShow"></router-view>
      </transition>
    </section>
    <back-top :height="200" :bottom="75" style="z-index:999999"></back-top>
     <!-- 查看图片dialog -->
    <el-dialog width="1000" custom-class="preview-dialog" :visible.sync="$root.previewVisible"
      @closed="nowImgClickNum = 0">
      <template slot="title">
        <div class="title-content">
          <div class="center">
            <div class="text">
              <img @click="rotateImg(-1)" class="left" src="@/assets/img/refresh-left.png" alt="" />
              图片预览
              <img @click="rotateImg(1)" src="@/assets/img/refresh-right.png" alt="" />
            </div>
          </div>
          <div class="download" v-if="$root.previewName">
            <!-- <el-button type="primary" @click="downLoadImg">下载</el-button> -->
          </div>
        </div>
      </template>
      <div class="img-wrap" v-loading="isImgLoading" element-loading-text="图片加载中">
        <img id="imageView" :src="$root.previewUrl" v-show="!isImgLoading" alt="图片预览" @load="loadingImg"
          @error="loadingImgError" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SideBar from "library/components/SideBar.vue";
import TopBar from "library/components/TopBar.vue";
import BackTop from "library/components/BackTop.vue";
import menu from "./common/config/menu";
// import Cookies from 'js-cookie';

export default {
  name: "App",
  components: {
    TopBar,
    BackTop,
    SideBar
  },
  data() {
    return {
      isMessageShow: false,
      menu,
      isImgLoading: true,
    };
  },

  methods: {
    messageShow(data) {
      this.isMessageShow = data;
    },
    // 图片加载完成
    loadingImg() {
      this.isImgLoading = false;
    },
      // 拷贝图片
    rotateBase64Img(src, edg, callback, err) {
      this.isImgLoading = true;
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");

      var imgW; //图片宽度
      var imgH; //图片高度
      var size; //canvas初始大小

      if (edg % 90 != 0) {
        console.error("旋转角度必须是90的倍数!");
        throw "旋转角度必须是90的倍数!";
      }
      edg < 0 && (edg = (edg % 360) + 360);
      const quadrant = (edg / 90) % 4; //旋转象限
      const cutCoor = { sx: 0, sy: 0, ex: 0, ey: 0 }; //裁剪坐标

      var image = new Image();
      image.crossOrigin = "Anonymous";
      if (src.includes("data:image")) {
        image.src = src;
      } else {
        image.src = src + "?time=" + new Date().getTime();
      }
      image.onerror = function () {
        err();
      };
      image.onload = function () {
        imgW = image.width;
        imgH = image.height;
        size = imgW > imgH ? imgW : imgH;

        canvas.width = size * 2;
        canvas.height = size * 2;
        switch (quadrant) {
          case 0:
            cutCoor.sx = size;
            cutCoor.sy = size;
            cutCoor.ex = size + imgW;
            cutCoor.ey = size + imgH;
            break;
          case 1:
            cutCoor.sx = size - imgH;
            cutCoor.sy = size;
            cutCoor.ex = size;
            cutCoor.ey = size + imgW;
            break;
          case 2:
            cutCoor.sx = size - imgW;
            cutCoor.sy = size - imgH;
            cutCoor.ex = size;
            cutCoor.ey = size;
            break;
          case 3:
            cutCoor.sx = size;
            cutCoor.sy = size - imgW;
            cutCoor.ex = size + imgH;
            cutCoor.ey = size + imgW;
            break;
        }

        ctx.translate(size, size);
        ctx.rotate((edg * Math.PI) / 180);
        ctx.drawImage(image, 0, 0);

        var imgData = ctx.getImageData(
          cutCoor.sx,
          cutCoor.sy,
          cutCoor.ex,
          cutCoor.ey
        );
        if (quadrant % 2 == 0) {
          canvas.width = imgW;
          canvas.height = imgH;
        } else {
          canvas.width = imgH;
          canvas.height = imgW;
        }
        ctx.putImageData(imgData, 0, 0);
        callback(canvas.toDataURL());
      };
    },
  // 旋转图片
    rotateImg(flag) {
      this.rotateBase64Img(
        this.$root.previewUrl,
        flag * 90,
        (image) => {
          this.isImgLoading = false;
          this.$root.previewUrl = image;
        },
        () => {
          this.isImgLoading = false;
        }
      );
    },
    loadingImgError() {
      this.isImgLoading = false;
      this.$root.previewVisible &&
        this.$message.warning("图片加载失败，请刷新或重新打开");
    },
    downLoadImg() {
      window.open(
        `/commonUpload/download.json?name=${encodeURIComponent(
          this.$root.previewName
        )}&url=${this.$root.previewUrl}`
      );
    },
  },
  computed: {
    cachedViews() {
      return this.$store.state.cachedViews || [];
    },
    sidebar() {
      return this.$store.state.sidebar || {};
    },
    iszongbuyusuanLeader() {
      // console.log("this.$store.state.userInfo", this.$store.state)
      if(this.$store.state.userInfo && this.$store.state.userInfo.curRole) {
        return this.$store.state.userInfo.curRole.roleId == 15
      }
      return false
    }
  },

  created() {
    // this.$store.dispatch("updateGlobalConfig");
    // if() {

    // }
  },
  
};
</script>

<style lang="scss">
// 查看图片弹框
.preview-dialog {
    width: 1000px;
    text-align: center;

    img {
        max-width: 100%;
    }
}
.title-content {
  position: relative;

  >.center {
    >.text {
      line-height: 17px;
      position: relative;

      >img {
        position: absolute;
        cursor: pointer;
        width: 45px;
        top: calc(50% - 22px);
        right: calc(50% - 95px);

        &.left {
          left: calc(50% - 95px);
          right: auto;
        }
      }
    }
  }

  >.download {
    display: block;
    position: absolute;
    left: -15px;
    top: -8px;
  }
}
@import "./assets/scss/main.scss";
//解决elementUI表格表头错位问题
body .el-table th.gutter {
  display: table-cell !important;
}
body .el-table colgroup.gutter {
  display: table-cell !important;
}
#app .hide-sidebar{
  margin-left: 0;
  transition:  margin-left .3s;
}
#app {
  min-width: 1200px;
}
</style>
